// Mxltiverse — Shared constants

import type { DurationTier, MusicalMood, Language, Outcome } from './types';

export const LANGUAGES: Language[] = ['es', 'en', 'pt'];

export const LANGUAGE_LABELS: Record<Language, string> = {
  es: 'Espanol',
  en: 'English',
  pt: 'Portugues',
};

export interface DurationConfig {
  label: string;
  min_min: number;
  max_min: number;
  turn_budget: number;
  act_count: number;
}

export const DURATION_TIERS: Record<DurationTier, DurationConfig> = {
  quick_play: { label: 'Quick Play', min_min: 10, max_min: 15, turn_budget: 10, act_count: 3 },
  aventura:   { label: 'Aventura',   min_min: 20, max_min: 30, turn_budget: 22, act_count: 4 },
  historia:   { label: 'Historia',   min_min: 45, max_min: 60, turn_budget: 48, act_count: 5 },
};

export const MUSICAL_MOODS: MusicalMood[] = [
  'exploration', 'combat', 'tension', 'dialogue', 'victory', 'defeat',
];

export const DIFFICULTIES = {
  easy: 8,
  normal: 12,
  hard: 16,
  extreme: 20,
} as const;

export const OUTCOME_THRESHOLDS = {
  critical_success_margin: 5,
  partial_success_margin: 0,
  critical_failure_threshold: 1,
} as const;

export const AI_MODELS = {
  master: '@cf/meta/llama-3.1-8b-instruct-fast',
  npc: '@cf/meta/llama-3.1-8b-instruct-fast',
} as const;

export const MAX_ACTIVE_NPCS = 5;
export const MAX_NPCS_REACT_PER_TURN = 3;
export const OTP_TTL_SECONDS = 600;
export const JWT_TTL_DAYS = 7;
export const MAX_HP_BASE = 20;
export const STAT_POOL = 30;
export const STAT_MIN = 1;
export const STAT_MAX = 10;

export const GENRES = [
  'fantasy_epic',
  'noir',
  'action',
  'drama',
  'comedy',
  'horror',
  'mystery',
  'adventure',
] as const;

export const BOOKER_ARCS = [
  'overcoming_monster',
  'rags_to_riches',
  'the_quest',
  'voyage_return',
  'comedy',
  'tragedy',
  'rebirth',
] as const;
